{
  "versi": 1,
  "kuis": {
    "batasLulus": 80,
    "pilihanJumlahSoal": [30, 40, 50],
    "jumlahSoalAwal": 30,
    "percobaanPerLangkah": 2,
    "peringkat": true
  },
  "mapel": [
    {
      "id": "matematika",
      "nama": "Matematika",
      "aktif": true,
      "keterangan": "Bilangan, Geometri & Pengukuran, Data",
      "simbol": "+ − × ÷",
      "rumus": "rumus/matematika.json",
      "bankSoal": {
        "file": "bank-soal/matematika.json",
        "porsi": 0.2
      },
      "bobotTopik": {
        "pecahan-senilai": 1,
        "urutan-pecahan": 1,
        "pecahan-desimal-persen": 1,
        "diskon": 1,
        "bilangan-cacah": 2,
        "tambah-kurang-pecahan": 2,
        "kali-bagi-pecahan": 2,
        "kpk": 2,
        "fpb": 1,
        "faktor-kelipatan": 1,
        "banding-setengah": 1,
        "cukup-uang": 1,
        "keliling-luas": 1,
        "luas-bangun": 1,
        "sifat-bangun-datar": 1,
        "volume": 1,
        "kubus-satuan": 1,
        "tampak-bangun": 1,
        "dadu": 1,
        "satuan-panjang": 1,
        "satuan-berat": 1,
        "satuan-volume": 1,
        "muat-wadah": 1,
        "waktu": 1,
        "tepat-waktu": 1,
        "kecepatan": 1,
        "sudut": 1,
        "penaksiran": 1,
        "pembagian-bersisa": 1,
        "diagram-batang": 2,
        "piktogram": 2,
        "tabel-frekuensi": 2,
        "kesimpulan-data": 1
      }
    },
    {
      "id": "bahasa-indonesia",
      "nama": "Bahasa Indonesia",
      "aktif": true,
      "keterangan": "Teks informasi & teks fiksi",
      "simbol": "Aa",
      "bankSoal": {
        "file": "bank-soal/bahasa-indonesia.json",
        "porsi": 0.4
      },
      "bobotTopik": {
        "gagasan-pokok": 1,
        "topik-judul": 1,
        "kalimat-utama": 1,
        "informasi-tersurat": 1,
        "makna-kata": 1,
        "sebab-akibat": 1,
        "kesesuaian-isi": 1,
        "simpulan": 1,
        "membandingkan-teks": 1,
        "sikap-refleksi": 1,
        "kosakata-bidang": 1,
        "ikhtisar": 1,
        "gagasan-pendukung": 1,
        "fakta-opini": 1,
        "tokoh": 1,
        "watak": 1,
        "latar": 1,
        "alur-peristiwa": 1,
        "perasaan-tokoh": 1,
        "amanat": 1,
        "tema": 1,
        "objek-kosakata": 1,
        "perubahan": 1,
        "ungkapan": 1,
        "relevansi": 1,
        "respons-emosional": 1
      }
    }
  ]
}
